import React from 'react';
import FormModal, { ModalProps } from './FormModal';

const CreateModal: React.FC<ModalProps> = ({
  children,
  ...rest
}) => (
  <FormModal {...rest} buttonText="Opret">
    {children}
  </FormModal>
);

export default CreateModal;
